export default __webpack_public_path__ + "static/media/user_white.607d1e8a.svg";